import clsx from 'clsx';
import { useEffect, useState } from 'react';
import { useSelector } from 'react-redux';
import { useSearchParams } from 'react-router-dom';
import { selectAllThreads } from '../../store/api/threadsApi';
import { CategoryAva } from './CategoryAva';

export function CategoryList() {
  const [searchParams, setSearchParams] = useSearchParams();
  const params = searchParams.get('category') || '';
  const threads = useSelector(selectAllThreads);
  const mapped = threads.map((thread) => thread.category);
  const categories = mapped.reduce((acc, curr) => {
    if (!acc.includes(curr)) {
      return [...acc, curr];
    }
    return acc;
  }, []);

  const [prevScrollPos, setPrevScrollPos] = useState(0);
  const [visible, setVisible] = useState(true);

  const handleScroll = () => {
    const currentScrollPos = window.scrollY;

    if (currentScrollPos > prevScrollPos) {
      setVisible(false);
    } else {
      setVisible(true);
    }

    setPrevScrollPos(currentScrollPos);
  };

  useEffect(() => {
    window.addEventListener('scroll', handleScroll);

    return () => window.removeEventListener('scroll', handleScroll);
  });

  return (
    <div
      className={clsx(
        'sticky z-20 mx-1 flex items-center justify-center overflow-auto rounded-2xl bg-indigo-50/90 supports-[backdrop-filter]:bg-indigo-100/40 supports-[backdrop-filter]:backdrop-blur dark:bg-gray-900/90 dark:supports-[backdrop-filter]:bg-gray-900/40',
        [visible ? 'top-14 md:top-0' : '']
      )}
    >
      <ul className="inline-block gap-1 whitespace-nowrap">
        {categories.map((category) => (
          <li key={category} className="inline-flex">
            <button
              onClick={() => {
                if (params === category) {
                  setSearchParams('');
                } else {
                  setSearchParams({ category });
                }
              }}
              className={clsx(
                'flex w-fit max-w-[100px] flex-col items-center gap-1 overflow-hidden rounded-2xl p-2 text-xs',
                [
                  params === category
                    ? 'bg-indigo-500/20 dark:bg-indigo-500/10'
                    : '',
                ]
              )}
            >
              <CategoryAva category={category} />
              {category}
            </button>
          </li>
        ))}
      </ul>
    </div>
  );
}
